var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"hiq-loader"},[_c('span',{staticClass:"show-for-sr",attrs:{"aria-live":"polite"}},[_vm._v(_vm._s(_vm.translations.loading))]),_c('div'),_c('div'),_c('div'),_c('div')]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }